export default "__VITE_ASSET__9073cb4e__"